import { useIsTablet } from "@ac-expo/ui-components";
import Link from "next/link";

export function DownloadAppsSection() {
  const isTablet = useIsTablet();

  return (
    <div
      className="mx-3 my-4 flex justify-center rounded-3xl bg-gradient-to-bl from-[#F39200] to-[#93370D] xl:mx-20 xl:my-24"
      style={{
        boxShadow:
          "0px 8px 8px -4px rgba(16, 24, 40, 0.08), 0px 20px 24px -4px rgba(16, 24, 40, 0.14)",
      }}
    >
      <div className="flex flex-col gap-8 p-16 py-36 max-xl:items-center xl:w-1/2">
        <p className="text-4xl font-bold leading-10 text-white">
          Multi-supports
        </p>
        <p className="text-lg font-normal leading-6 text-white">
          Connect’Events est disponible sur ordinateurs, tablettes, téléphones
          au format Web App ou application mobile.
        </p>
        <div className="flex w-fit flex-wrap max-xl:justify-center">
          <Link
            className="m-3 mt-0 shrink-0"
            href="https://play.google.com/store/apps/details?id=com.acexpoorganization.connectevents"
          >
            <img
              className="h-14"
              src="/images/svg/google_play_badge_white.svg"
              alt="Télécharger sur le Play Store"
            />
          </Link>
          <Link
            className="m-3 mt-0 shrink-0"
            href="https://apps.apple.com/us/app/connectevents/id6503937582"
          >
            <img
              className="h-14"
              src="/images/svg/app_store_badge_white.svg"
              alt="Télécharger sur l'App Store"
            />
          </Link>
        </div>
      </div>
      {!isTablet && (
        <div className="flex w-1/2 justify-center overflow-hidden">
          <div className="relative w-full">
            <img
              className="absolute bottom-0 h-[90%] max-2xl:left-60 2xl:right-0"
              src="/images/ipad_mockup.png"
              alt="Mockup d'un ipad"
            />
            <img
              className="absolute bottom-0 h-4/5 2xl:right-60"
              src="/images/iPhone_mockup.png"
              alt="Mockup d'un smartphone iPhone"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default DownloadAppsSection;
